module.exports = __webpack_public_path__ + "images/assets/92aa4227ecc8bb155bef5946c8bf2774.svg";